import { CSSProperties, DefaultTheme } from 'styled-components';
import { withTheme } from 'styled-components';

import { StyContainer, StyCircularGlow } from './styles';

interface ICircularGlow {
  colorStart?: string;
  colorEnd?: string;
  width?: string;
  height?: string;
  filterBlur?: string;
  opacity?: number;
  top?: string;
  animationBreathingTime?: string;
  theme?: DefaultTheme;
  style?: CSSProperties;
}

export const CircularGlow: React.FC<ICircularGlow> = withTheme(
  ({
    colorStart = '#3ee089',
    colorEnd = '#007e87',
    width = '250px',
    height = '250px',
    filterBlur = '80px',
    opacity = 0.6,
    top = '50%',
    animationBreathingTime = '15s',
    style,
  }: ICircularGlow) => {
    return (
      <StyContainer filterBlur={filterBlur} top={top} style={style}>
        <StyCircularGlow
          colorStart={colorStart}
          colorEnd={colorEnd}
          width={width}
          height={height}
          filterBlur={filterBlur}
          opacity={opacity}
          animationBreathingTime={animationBreathingTime}
        />
      </StyContainer>
    );
  }
);
